/* projects/speaker-platform/src/app/molecules/dialog/dialog.component.scss */
.dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  inset: 0;
  -webkit-backdrop-filter: blur(0);
  backdrop-filter: blur(0);
  z-index: -9999;
  visibility: hidden;
  transition:
    visibility 0.1s,
    z-index 0.1s,
    background-color 0.3s 0.1s,
    backdrop-filter 0.3s 0.1s;
  overflow-y: auto;
}
.dialog__wrapper {
  width: 600px;
  padding: 32px;
  background-color: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 15px;
  transform: scale(0);
  transition: transform 0.3s 0.1s;
}
.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.dialog__header h4 {
  margin-bottom: 0;
  font-size: 18px;
}
.dialog__footer {
  text-align: right;
}
.dialog__footer--hascontent {
  margin-top: 32px;
}
.dialog.dialog--visible {
  z-index: 9999;
  visibility: visible;
  background-color: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}
.dialog.dialog--visible .dialog__wrapper {
  transform: scale(1);
}
.dialog.dialog--out {
  transition:
    visibility 0.1s 0.4s,
    z-index 0.1s 0.4s,
    background-color 0.3s 0.1s,
    backdrop-filter 0.3s 0.1s;
}
.dialog.dialog--out .dialog__wrapper {
  transition: transform 0.3s;
}
/*# sourceMappingURL=dialog.component-HLMEUMUJ.css.map */
